/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForServiceAccountResourceOntologySync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForServiceAccountResourceOntologySync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForServiceAccountResourceOntologySync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForServiceAccountResourceOntologySync>): BackgroundJobPayloadForServiceAccountResourceOntologySync {
        let obj = Object.assign(new BackgroundJobPayloadForServiceAccountResourceOntologySync(), model);
        BackgroundJobPayloadForServiceAccountResourceOntologySync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForServiceAccountResourceOntologySync>): BackgroundJobPayloadForServiceAccountResourceOntologySync {
        if (!model) return null;
        return BackgroundJobPayloadForServiceAccountResourceOntologySync.newInstance(<BackgroundJobPayloadForServiceAccountResourceOntologySync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForServiceAccountResourceOntologySync) {
        if (!obj) return;

        models.BackgroundJobPayloadForServiceAccountResourceOntologySync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForServiceAccountResourceOntologySync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForServiceAccountResourceOntologySync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service account whose service_resource_inventory_v2 resources are synced to the Workload ontology in GraphDB.
     */
    service_account_id: string;

}
